const getters = {
    allProductCategories: state => state.productCategories,
    getListOfProductCategoryIds: state => state.listOfProductCategoryIds
};

const state = {
    productCategories: [],
    listOfProductCategoryIds: [],
    product_id: null
};

const mutations = {
    setProductCategories(state, newCategories) {
        state.productCategories = newCategories
    },
    setListOfProductCategoryIds(state, list) {
        state.listOfProductCategoryIds = list
    },
    setProductId(state, id) {
        state.product_id = id
    }
};

const actions = {
    setProductCategories({commit},newCategories) {
        commit('setProductCategories', newCategories);
    },
    setListOfProductCategoryIds({commit}, list) {
        commit('setListOfProductCategoryIds', list);

    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};